import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { endpoints } from 'environments/endpoints';
import { Actor } from 'app/shared/models/actors-users/actor.model';
import { HttpHeadersUtil } from 'app/shared/utils/http-headers.util';

@Injectable({
  providedIn: 'root'
})
export class ActorService {
  private baseRoute = environment.GATEWAY_API + endpoints.actor.baseRoute;
  private subRoutes = endpoints.actor.subRoutes;

  constructor(private _httpClient: HttpClient) {}

  getAll(): Observable<Actor[]> {
    return this._httpClient.get<Actor[]>(
      `${this.baseRoute}${this.subRoutes.getAll}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getAllByType(actorType: string): Observable<Actor[]> {
    return this._httpClient.get<Actor[]>(
      `${this.baseRoute}${this.subRoutes.getAllByType + actorType}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getAllActiveByType(actorType: string, id: string): Observable<Actor[]> {
    if (id === null) id = '00000000-0000-0000-0000-000000000000';
    return this._httpClient.get<Actor[]>(
      `${this.baseRoute}${this.subRoutes.getAllActiveByType + actorType + '/' + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getById(id: string): Observable<Actor> {
    return this._httpClient.get<Actor>(
      `${this.baseRoute}${this.subRoutes.getById + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getBySiret(siret: string): Observable<Actor[]> {
    return this._httpClient.get<Actor[]>(
      `${this.baseRoute}${this.subRoutes.getBySiret + siret}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  add(item: Actor): Observable<Actor> {
    return this._httpClient.post<Actor>(
      `${this.baseRoute}${this.subRoutes.add}`,
      item,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  edit(item: Actor): Observable<Actor> {
    return this._httpClient.put<Actor>(
      `${this.baseRoute}${this.subRoutes.update}`,
      item,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getDataChanges(id: string): Observable<string> {
    return this._httpClient.get<string>(
      `${this.baseRoute}${this.subRoutes.getDataChanges + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  exportExcel(actorType: string, title: string): Observable<Blob> {
    return this._httpClient.get(
      `${this.baseRoute}${this.subRoutes.exportExcel + actorType + '/' + encodeURIComponent(title)}`,
      {
        responseType: 'blob'
      }
    );
  }
}
